import { useParams } from 'src/routes/hooks';
import UserEditView from 'src/sections/management/user/view/user-edit-view';

export default function UserEdit() {
  const { id } = useParams();

  return <UserEditView id={id!} />;
}
